import ToggleOff from 'assets/icons/md/md-toggle-off.svg'

ToggleOff.displayName = 'ToggleOff'
export default ToggleOff
